import React from "react";
import { Box, Button, Flex, Text } from "rebass";

import { UploadSVG } from "../../svg/UploadSVG";

interface IProps {
  accept: string[];
  openFileSelection(): void;
}

export const Placeholder: React.FC<IProps> = ({ accept, openFileSelection }) => (
  <Flex
    m="auto"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
  >
    <Box color="wild-blue">
      <UploadSVG size={115} />
    </Box>

    <Text
      as="p"
      fontSize="18px"
      fontWeight={500}
      color="zodiac"
    >
      Drag and drop to upload
    </Text>

    <Text
      as="p"
      color="#a2a5be"
      font-weight={500}
    >
      <span>or</span>

      &nbsp;

      <Button
        type="button"
        px={0}
        py={0}
        color="sp-blue"
        bg="transparent"
        onClick={openFileSelection}
      >
        browse
      </Button>

      &nbsp;

      <span>to choose a file</span>
    </Text>

    <Text
      as="p"
      mt="16px"
      fontSize="16px"
      fontWeight={500}
      lineHeight={1.44}
      color="#a2a5be"
    >
      {`(${accept.join(', ')} supported)`}
    </Text>
  </Flex>
);
